module.exports = __webpack_public_path__ + "img/15.a88396e8.jpg";